module.exports = __webpack_public_path__ + "media/images/logo-46eeeeeecb95a4243da86aad0a9fddd6.png";